import type {PropsWithChildren} from 'react'
import type {CustomizationConfig} from '@goschool/model'
import {CustomGoSchoolContext} from '@goschool/model'


export type CustomGoSchoolContextProviderProps = PropsWithChildren & CustomizationConfig

export function CustomGoSchoolContextProvider(props: CustomGoSchoolContextProviderProps) {
  const {children, ...config} = props
  return <CustomGoSchoolContext.Provider value={config}>{children}</CustomGoSchoolContext.Provider>
}

